import React from "react";
import { ISearchField, ISearchProp } from "../Types";
import { Input } from "antd";

type PropType = ISearchProp & ISearchField;
export const SearchInput = (props: PropType) => {
    return <Input
        allowClear
        datatype="round"
        className="ant-input-round"
        placeholder={props.placeholder as string}
        onPressEnter={() => props.triggerSearch ? props.handleSearch?.() : null}
        value={props.searchValues?.[props.fieldName]}
        onChange={(e) => {
            props.onChange?.({ [props.fieldName]: e.target.value })
            // if (props.triggerSearch) props.handleSearch?.();
        }}
        disabled={props.disabled} />
}